function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m60.709 11.623a5.3173 5.3173 0 0 0-5.8133 1.1573l-6.896 6.896-12.229-12.229a5.3333 5.3333 0 0 0-7.5413 0l-12.229 12.229-6.896-6.896a5.3333 5.3333 0 0 0-9.104 3.7707v28.229a13.349 13.349 0 0 0 13.333 13.333h37.333a13.349 13.349 0 0 0 13.333-13.333v-28.229a5.3333 5.3333 0 0 0-3.2907-4.928zm-2.0427 33.157a8 8 0 0 1-8 8h-37.333a8 8 0 0 1-8-8v-28.229l8.7813 8.7813a2.6667 2.6667 0 0 0 3.7707 0l14.115-14.115 14.115 14.115a2.6667 2.6667 0 0 0 3.7707 0l8.7813-8.7813z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6667
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.051482e1.svg";
export { ForwardRef as ReactComponent };